"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clear3HighOrderBitsOnInt32 = clear3HighOrderBitsOnInt32;
exports.channelIdFromChannelGroupAndPriority = channelIdFromChannelGroupAndPriority;
exports.priorityFromChannel = priorityFromChannel;
exports.channelGroupFromChannel = channelGroupFromChannel;
function setPriorityBits(num, priority2bits) {
    // set bit 29 and 30 to encode the priority (we don't want to use bit 31 since it is the sign bit)
    return BigInt(num) | (BigInt(priority2bits) << 29n);
}
function getPriorityBits(num) {
    // get bit 29 and 30
    return (BigInt(num) >> 29n) & 3n;
}
function clear3HighOrderBitsOnInt32(num) {
    return Number(BigInt(num) & 0x1fffffffn);
}
// Channel priority is encoded in the 2 high order bits of the channel
// in order to retain compatibility with the pre-existing channels
// which all have priority 0.
function channelIdFromChannelGroupAndPriority(channelGroup, priority) {
    return Number(BigInt.asIntN(32, setPriorityBits(channelGroup, priority)));
}
function priorityFromChannel(channelId) {
    return Number(getPriorityBits(channelId));
}
function channelGroupFromChannel(channelId) {
    return clear3HighOrderBitsOnInt32(channelId);
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY2hhbm5lbElkLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vc3JjL2NoYW5uZWxJZC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQVVBLGdFQUVDO0FBT0Qsb0ZBRUM7QUFFRCxrREFFQztBQUVELDBEQUVDO0FBN0JELFNBQVMsZUFBZSxDQUFDLEdBQVcsRUFBRSxhQUE4QjtJQUNoRSxrR0FBa0c7SUFDbEcsT0FBTyxNQUFNLENBQUMsR0FBRyxDQUFDLEdBQUcsQ0FBQyxNQUFNLENBQUMsYUFBYSxDQUFDLElBQUksR0FBRyxDQUFDLENBQUE7QUFDdkQsQ0FBQztBQUVELFNBQVMsZUFBZSxDQUFDLEdBQVc7SUFDaEMsb0JBQW9CO0lBQ3BCLE9BQU8sQ0FBQyxNQUFNLENBQUMsR0FBRyxDQUFDLElBQUksR0FBRyxDQUFDLEdBQUcsRUFBRSxDQUFBO0FBQ3BDLENBQUM7QUFFRCxTQUFnQiwwQkFBMEIsQ0FBQyxHQUFXO0lBQ2xELE9BQU8sTUFBTSxDQUFDLE1BQU0sQ0FBQyxHQUFHLENBQUMsR0FBRyxXQUFXLENBQUMsQ0FBQTtBQUM1QyxDQUFDO0FBSUQsc0VBQXNFO0FBQ3RFLGtFQUFrRTtBQUNsRSw2QkFBNkI7QUFDN0IsU0FBZ0Isb0NBQW9DLENBQUMsWUFBb0IsRUFBRSxRQUF5QjtJQUNoRyxPQUFPLE1BQU0sQ0FBQyxNQUFNLENBQUMsTUFBTSxDQUFDLEVBQUUsRUFBRSxlQUFlLENBQUMsWUFBWSxFQUFFLFFBQVEsQ0FBQyxDQUFDLENBQUMsQ0FBQTtBQUM3RSxDQUFDO0FBRUQsU0FBZ0IsbUJBQW1CLENBQUMsU0FBaUI7SUFDakQsT0FBTyxNQUFNLENBQUMsZUFBZSxDQUFDLFNBQVMsQ0FBQyxDQUFvQixDQUFBO0FBQ2hFLENBQUM7QUFFRCxTQUFnQix1QkFBdUIsQ0FBQyxTQUFpQjtJQUNyRCxPQUFPLDBCQUEwQixDQUFDLFNBQVMsQ0FBQyxDQUFBO0FBQ2hELENBQUMifQ==